import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FileText, Loader2, IdCard } from "lucide-react";
import { HoverPillButton } from "@/components/condomini/condominiHelpers";

export const VisuraSoggettoButton = ({ resident, building, index }) => {
  const [open, setOpen] = useState(false);
  const [cf, setCf] = useState(resident.codice_fiscale || "");
  const [busy, setBusy] = useState(false);
  const gated = building.subscription_status !== "attivo";
  const cfValid = /^[A-Za-z0-9]{11,16}$/.test((cf || "").trim());

  const buy = async () => {
    if (!cfValid) { toast.error("Inserisci un codice fiscale valido (11–16 caratteri)."); return; }
    setBusy(true);
    try {
      const r = await api.post("/catasto/visura-soggetto/checkout", {
        building_id: building.id, resident_id: resident.id,
        codice_fiscale: cf.trim().toUpperCase(), origin_url: window.location.origin,
      });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossibile avviare il pagamento", { duration: 7000 });
      setBusy(false);
    }
  };

  return (
    <>
      <HoverPillButton data-testid={`visura-soggetto-btn-${index}`}
        title={gated ? "Condominio non collegato" : "Visura catastale per soggetto (€8)"}
        disabled={gated} onClick={() => { setCf(resident.codice_fiscale || ""); setOpen(true); }}
        icon={FileText} label="Visura €8" hover="blue" className="text-muted-foreground" />

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="visura-soggetto-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><IdCard className="h-5 w-5 text-[#007BFF]" />Visura per soggetto</DialogTitle>
            <DialogDescription>
              Verrà generata la <b>visura catastale nazionale</b> intestata al codice fiscale di <b>{resident.nome || "questo condòmino"}</b>,
              con l'elenco di tutti gli immobili a suo nome. Costo <b>€8,00</b> (IVA inclusa).
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-2">
            <label className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Codice fiscale del condòmino</label>
            <Input data-testid="visura-soggetto-cf" value={cf}
              onChange={(e) => setCf(e.target.value.toUpperCase())}
              placeholder="Es. RSSMRA80A01F205X" maxLength={16} className="font-mono uppercase" />
            {!resident.codice_fiscale && (
              <p className="text-xs text-amber-600">Questo condòmino non ha un codice fiscale in anagrafica: inserendolo qui verrà salvato anche nella scheda del condòmino.</p>
            )}
          </div>
          <DialogFooter className="gap-2">
            <Button variant="outline" onClick={() => setOpen(false)}>Annulla</Button>
            <Button data-testid="visura-soggetto-buy" onClick={buy} disabled={busy || !cfValid} className="bg-[#007BFF] hover:bg-[#0056B3]">
              {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileText className="h-4 w-4 mr-2" />}Acquista visura · €8
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
